import styled from 'styled-components';

const BudgeWrapper = styled.div`
    position: relative;
    cursor: pointer;
`;

export default BudgeWrapper;
